import { useTheme } from "@mui/material"
const baseHeight = 211;
const baseWidth = 21;

export default function LogoName({
  width = 211,
  height
}) {
  const theme = useTheme();

  const finalWidth = width,
  finalHeigth = height ?? (finalWidth * baseWidth) / baseWidth;

  return (
    <svg 
      viewBox="0 0 211 21"
      width={finalWidth}
      height={finalHeigth}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.6997 0C5.30543 0 3.99244 0.938698 3.2795 1.82393V0.285174H0V20.6751H3.2795V13.5458C3.99244 14.431 5.30543 15.3697 7.6997 15.3697C11.0921 15.3697 14.5736 12.5714 14.5736 7.67C14.5736 2.76857 11.0921 0 7.6997 0ZM6.86794 12.2387C5.29949 12.2387 4.04591 11.5555 3.27356 10.498V4.87767C4.04591 3.82015 5.29949 3.13692 6.86794 3.13692C9.17904 3.13692 11.1159 4.93114 11.1159 7.67C11.1159 10.4089 9.17904 12.2387 6.86794 12.2387Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M36.764 0.285156H32.8548L27.7514 6.4164V0.285156H24.4719V6.4164L19.3981 0.285156H15.4592L21.1626 7.21845L15.2334 15.0905H19.2555L24.4719 8.15715V15.0905H27.7514V8.15715L32.9974 15.0905H36.9898L31.0606 7.21845L36.764 0.285156Z"
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M52.9054 0.285156H41.8371L41.439 4.50336C41.1241 7.98486 40.6429 10.5811 39.9834 11.9476H38.3853V18.7918H41.5816V15.0845H51.7053V18.7918H54.8719V11.9535H52.9054V0.285156ZM49.5962 11.9535H43.2392C43.7501 10.7297 44.1244 8.61462 44.3799 5.85199L44.6056 3.39831H49.5962V11.9535Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M63.7659 5.87598H60.0586V9.61295H63.7659V5.87598Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M79.9385 10.6702L75.4292 0.285156H70.9258V15.0905H74.1162V4.3073L78.8512 15.0905H80.9603L85.7251 4.3073V15.0905H88.9215V0.285156H84.4418L79.9385 10.6702Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M99.2459 0.029541C95.1109 0.029541 92.0571 3.10705 92.0571 7.55695C92.0571 12.4346 95.5921 15.3695 100.155 15.3695C102.496 15.3695 104.516 14.5437 105.745 13.0584L103.951 10.8365C103.036 11.692 101.872 12.3752 100.131 12.3752C97.624 12.3752 95.7406 10.9493 95.4792 8.69765H106.031V7.1886C106.031 2.94069 103.351 0.029541 99.2459 0.029541ZM95.4792 6.13108C95.6515 4.53292 96.8754 2.88128 99.1865 2.88128C101.153 2.88128 102.549 4.19427 102.692 6.13108H95.4792Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M122.251 0.285156H111.182L110.784 4.50336C110.469 7.98486 109.988 10.5811 109.329 11.9476H107.73V18.7918H110.927V15.0845H121.05V18.7918H124.217V11.9535H122.251V0.285156ZM118.941 11.9535H112.584C113.095 10.7297 113.47 8.61462 113.725 5.85199L113.951 3.39831H118.941V11.9535Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M130.324 10.0405V0.285156H127.045V15.0905H130.241L137.198 5.36482V15.0905H140.508V0.285156H137.311L130.324 10.0405Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M157.475 0.285156H154.196V11.9535H147.72V0.285156H144.44V15.0905H156.335V18.7977H159.525V11.9535H157.475V0.285156Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M165.621 10.0405V0.285156H162.341V15.0905H165.538L172.495 5.36482V15.0905H175.804V0.285156H172.608L165.621 10.0405Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M189.717 5.98864H183.016V0.285156H179.736V15.0905H183.016V9.12556H189.717V15.0905H192.997V0.285156H189.717V5.98864Z" 
        fill={theme.palette.rgd.logoName}
      />
      <path 
        d="M207.44 0.285174V1.85363C206.757 0.968404 205.414 0 202.99 0C199.598 0 196.116 2.76857 196.116 7.67C196.116 12.5774 199.598 15.3697 202.99 15.3697C205.414 15.3697 206.757 14.4013 207.44 13.5161V15.0845H210.719V0.285174H207.44ZM207.44 10.4386C206.697 11.5198 205.384 12.2328 203.816 12.2328C201.505 12.2328 199.568 10.4089 199.568 7.67C199.568 4.93114 201.505 3.13692 203.816 3.13692C205.384 3.13692 206.697 3.84985 207.44 4.93114V10.4386Z" 
        fill={theme.palette.rgd.logoName}
      />
    </svg>

  )
}